import { z } from 'zod';
import { OrgNicheSchema } from './org-schemas.js';
// ── Field catalog (single source of truth — JQ4-18 / US-CONFIG-004) ────────
//
// JQ4-21 MUST import CheckinFieldId, CHECKIN_FIELD_CATALOG from this module.
// It MUST NOT redefine them.
export const CHECKIN_FIELD_IDS = [
    'plate',
    'first_name',
    'last_name',
    'phone',
    'visitor_email',
    'room_number',
    'visitor_type',
    'parking_zone',
    'valet_notes',
];
export const CheckinFieldIdSchema = z.enum(CHECKIN_FIELD_IDS);
export const CHECKIN_FIELD_CATALOG = [
    { id: 'plate', locked: true, nicheOnly: null, defaultRequired: true },
    { id: 'first_name', locked: false, nicheOnly: null, defaultRequired: false },
    { id: 'last_name', locked: false, nicheOnly: null, defaultRequired: false },
    { id: 'phone', locked: false, nicheOnly: null, defaultRequired: false },
    { id: 'visitor_email', locked: false, nicheOnly: null, defaultRequired: false },
    { id: 'room_number', locked: false, nicheOnly: 'hotel', defaultRequired: false },
    { id: 'visitor_type', locked: false, nicheOnly: 'hotel', defaultRequired: false },
    { id: 'parking_zone', locked: false, nicheOnly: null, defaultRequired: false },
    { id: 'valet_notes', locked: false, nicheOnly: null, defaultRequired: false },
];
// ── Per-field view schema (merged: stored required flag + static metadata) ──
export const CheckinFieldConfigSchema = z.object({
    id: CheckinFieldIdSchema,
    required: z.boolean(),
    locked: z.boolean(),
    nicheOnly: z.enum(['hotel']).nullable(),
});
// ── Request (PUT) ────────────────────────────────────────────────────────────
//
// Partial map — missing keys default to false (except plate which defaults true).
// Unknown keys (not in CheckinFieldId) are IGNORED by the use case (forward-compat).
export const UpdateCheckinConfigRequestSchema = z.object({
    fields: z.record(CheckinFieldIdSchema, z.boolean()),
});
// ── Response (GET / PUT) ─────────────────────────────────────────────────────
//
// JQ4-21 DEPENDS on this shape. Do NOT change it without a versioning decision.
// updatedAt is null when no config row has been persisted yet (default view).
export const CheckinConfigResponseSchema = z.object({
    locationId: z.string().uuid(),
    organizationId: z.string().uuid(),
    locationNiche: OrgNicheSchema,
    fields: z.array(CheckinFieldConfigSchema),
    updatedAt: z.string().nullable(),
});
//# sourceMappingURL=checkin-config-schemas.js.map